export enum ExportType {
  none = 'none',
  ppt = 'ppt',
  xls = 'xls'
}

export enum Section {
  Dashboard = 'Dashboard',
  BookedForSales = 'BookedForSales',
  Agenda = 'Agenda',
  Watches = 'Watches',
  Allocation = 'Allocation',
  Map = 'Map',
  Creations = 'Creations',
  Tray = 'Tray',
  ExtraTrays = 'Extra_Trays',
  Activity = 'Activity',
  AppointmentAnalytics = 'Appointment_Analytics',
  ProductsAnalytics = 'Products_Analytics',
  Finance = 'Finance',
}

export enum ExportFormat {
  XLSX = "XLSX",
  PPT = "PPT"
}
